/* Sorğu formasında seçilən otaq/sinif siyahısı.
 *
 * YENİ OTAQ ƏLAVƏ ETMƏK: aşağıdakı müvafiq qrupa bir sətir yazmaq kifayətdir —
 * həm "Yeni sorğu" səhifəsində, həm də Sorğular səhifəsindəki formada
 * avtomatik görünür. Başqa yerdə dəyişiklik lazım deyil.
 */

// S101-S107 kimi ardıcıl nömrələri əl ilə yazmamaq üçün
const aralıq = (prefiks, ilk, son) =>
  Array.from({ length: son - ilk + 1 }, (_, i) => prefiks + (ilk + i));

export const OTAQ_QRUPLARI = [
  {
    qrup: 'Siniflər — S korpusu',
    otaqlar: [...aralıq('S', 101, 107), ...aralıq('S', 201, 208), ...aralıq('S', 301, 314)],
  },
  {
    qrup: 'Siniflər — E korpusu',
    otaqlar: [...aralıq('E', 101, 108), ...aralıq('E', 201, 210)],
  },
  {
    qrup: 'Laboratoriya və xüsusi otaqlar',
    otaqlar: [
      'Biologiya LAB', 'Fizika LAB', 'Kimya LAB',
      'Kitabxana (Prm.)', 'Kitabxana (Sc)',
      'MR2', 'MR3',
      'İmtahan otağı',
      'Steam mərkəz', 'Steam 2',
      'ART', 'Hərbi', 'İdman zalı',
    ],
  },
  {
    qrup: 'Müəllimlər otaqları',
    otaqlar: [
      'Müəllimlər otağı — Primary',
      'Müəllimlər otağı — Fənn',
      'Müəllimlər otağı — Secondary',
    ],
  },
  {
    qrup: 'Şöbələr və inzibati otaqlar',
    otaqlar: [
      'Direktor otağı', 'Katibə', 'Qəbul şöbəsi',
      'Mühasibat', 'HR', 'Təchizat',
      'Cafeteria', 'Yeməkxana',
    ],
  },
  {
    qrup: 'Mühafizə',
    otaqlar: ['Mühafizə — Mərkəzi post', 'Mühafizə — Bağça', 'Mühafizə — Parking'],
  },
  {
    qrup: 'Bağça',
    otaqlar: [
      'Bağça direktoru',
      'Pre-nursery',
      'Nursery (A)', 'Nursery (B)',
      'Reception (A)', 'Reception (B)',
      'Transition (A)', 'Transition (B)', 'Transition (C)', 'Transition (D)',
    ],
  },
];
